const faqs = {
  en: [
    {
      question: "How does the online physiotherapy work?",
      answer: `We create your personalized program based on the information you provide.
You are informed about all important details and exercises before you start.
During each session, you are reminded of common mistakes and key points to focus on.
You are guided step by step and can pause the session at any time.`,
    },
    {
      question: "Can I use my existing physiotherapy plan?",
      answer: `Yes you can. If your personal physiotherapist created costum therapy session, and you logged in under his code, you can access existing physiotherapy plan. For more information ask your personal physiotherapist.`,
    },
    {
      question: "Do I need special accessories at home?",
      answer: `No. There are different types of exercises available.
Some exercises can be done without any equipment, but we recommend accessories from our store
to help you perform more advanced exercises with bands, medicine balls and other tools.`,
    },
    {
      question: "How long is each session?",
      answer: `It depends. We create sessions of different lengths based on the information you provide.
We take into account your available time, exercise type and the main focus of each session.`,
    },
    {
      question: "Can I reschedule sessions?",
      answer: `You do not need to reschedule your sessions. If you do not have time, you can skip or stop a session at any point.
However, we recommend staying consistent for the best results.`,
    },
    {
      question: "Do you work with insurance?",
      answer: `Not yet. Our mission is to partner with insurance companies so that insured users can access plans at no extra cost.`,
    },
    {
      question: "Are my medical records secure?",
      answer: `Yes. Security is our top priority and your data is protected and not accessible to unauthorized persons.`,
    },
    {
      question: "Can I contact a specific physiotherapist for additional help?",
      answer: `Yes, you can. Additional costs may apply depending on your location and subscription plan.`,
    },
  ],
  sl: [
    {
      question: "Kako poteka spletna fizioterapija?",
      answer:
        `Na podlagi podatkov, ki nam jih posredujete, pripravimo osebni program.
Pred začetkom ste seznanjeni z vsemi pomembnimi informacijami in vajami.
Med posamezno vadbo vas opozarjamo na pogoste napake in ključne stvari, na katere morate biti pozorni.
Skozi vsako vadbo vas vodimo korak za korakom, vadbo pa lahko kadarkoli ustavite ali prekinete.`,
    },
    {
      question: "Ali lahko uporabim svoj obstoječi fizioterapevtski program?",
      answer:
        `Seveda lahko. Če je vaš osebni fizioterapevt ustvaril prilagojen terapevtski program in ste prijavljeni z njegovo kodo, lahko dostopate do obstoječega fizioterapevtskega načrta. Za več informacij se obrnite na svojega osebnega fizioterapevta.`,
    },
    {
      question: "Ali potrebujem kakšno posebno opremo doma?",
      answer:
        `Ne. Na voljo so različne vrste vaj.
Del vaj lahko izvajate brez pripomočkov, vseeno pa priporočamo nakup opreme v naši spletni trgovini,
da boste lahko izvajali zahtevnejše vaje z elastičnimi trakovi, medicinkami in drugimi pripomočki.`,
    },
    {
      question: "Kako dolgo traja posamezna vadba?",
      answer:
        `Odvisno je od vas. Pripravljamo vadbe različnih dolžin glede na podatke, ki nam jih posredujete.
Pri načrtovanju upoštevamo, koliko časa imate na voljo, vrsto vaj in glavni cilj posamezne vadbe.`,
    },
    {
      question: "Ali lahko prestavim vadbo?",
      answer:
        `Vadbe vam ni treba posebej prestavljati. Če nimate časa, jo lahko enostavno izpustite ali prekinete kadarkoli ter z njo nadaljujete kasneje.
Za najboljše rezultate vam priporočamo čim večjo rednost in doslednost.`,
    },
    {
      question: "Ali sodelujete z zavarovalnicami?",
      answer:
        `Za zdaj še ne. Načrtujemo skleniti partnerstva z zavarovalnicami,
da bi zavarovanim uporabnikom omogočili dostop do programov brez dodatnih stroškov.`,
    },
    {
      question: "Ali so moji zdravstveni podatki varni?",
      answer:
        `Da. Varnost vaših podatkov je na prvem mestu in so zaščiteni v skladu z visokimi standardi varovanja osebnih in zdravstvenih podatkov.`,
    },
    {
      question: "Ali se lahko obrnem na določenega fizioterapevta za dodatno pomoč?",
      answer:
        `Seveda. Po potrebi se lahko obrnete na izbranega fizioterapevta za dodatno pomoč,
pri čemer so lahko prisotni dodatni stroški glede na vašo lokacijo in izbran naročniški paket.`,
    },
  ],
};

export default faqs;
